import { WORK_REGISTER_PAGE_SIZE } from '../../config/settings/constant'

const adapterRecord = item => ({
  categoryCode: item?.codigoCategoria ?? null,
  consultantRegistrationCode: item?.codigoRegistroConsultor ?? '',
  consultantRegistrationDescription: item?.descripcionRegistroConsultor ?? '',
  expirationDate: item?.fechaCaducidad ?? '',
  sectorCode: item?.codigoRubro ?? '',
  sectorDescription: item?.descripcionRubro ?? '',
  specialtyCode: item?.codigoEspecialidad ?? '',
  specialtyDescription: item?.descripcionEspecialidad ?? '',
  statusCode: item?.codigoEstado ?? null,
  statusDescription: item?.descripcionEstado ?? '',
  subSpecialtyCode: item?.codigoSubEspecialidad ?? '',
  subSpecialtyDescription: item?.descripcionSubEspecialidad ?? ''
})

const adapterRecords = ins => ({
  content: ins?.content?.map(adapterRecord) ?? [],
  page: ins?.page ?? 1,
  size: ins?.size ?? WORK_REGISTER_PAGE_SIZE,
  totalElements: ins?.totalElements ?? 0,
  totalPages: ins?.totalPages ?? 0
})

const adapterRegistration = reg => ({
  expirationDate: reg?.fechaCaducidad ?? '',
  registrationCode: String(reg?.codigoRegistro ?? ''),
  registrationDescription: reg?.descripcionRegistro ?? '',
  statusCode: reg?.codigoEstado ?? null,
  statusDescription: reg?.descripcionEstado ?? '',
  supplierRut: reg?.rutProveedor ?? ''
})

export const adapterMinvuResponse = data => {
  if (!data || !data?.inscripciones || !data?.registro)
    return {
      records: [],
      registration: null
    }

  return {
    records: adapterRecords(data?.inscripciones),
    registration: adapterRegistration(data?.registro)
  }
}
